import React from 'react';
import { LayoutBox } from 'src/common/components/LayoutBox';
import { ContactPageContent } from 'src/public/components/contact';
import { Layout } from 'src/common/components/Layout';
import { VendorGetStaticProps } from 'vendor/utils/VendorGetStaticProps';
import { LayoutPanelLogoAndPartner } from 'src/common/components/Layout/LayoutPanelLogoAndPartner';

export const ContactPage = () => (
  <Layout title={'Kontakt'} rightPanel={null} leftPanel={<LayoutPanelLogoAndPartner />}>
    <LayoutBox>
      <ContactPageContent />
    </LayoutBox>
  </Layout>
);

export const getStaticProps = VendorGetStaticProps(() => ({
  props: {},
  revalidate: false,
}));

export default ContactPage;
